import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHighlighter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m11.25 17.25 8-9.5-3-3-9.5 8m4.5 4.5-6.5 2m6.5-2-4.5-4.5m-2 6.5 2-6.5m-2 6.5h14.5"
    />
  </svg>
);
export default SvgHighlighter;
